"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectingPersonDetail = exports.saveFavOptions = exports.performEsignAuth = exports.isActionTrackingToBeAcknowledged = exports.getUserSessionService = exports.getShortcutNavigationOptions = exports.getPersonasForUserApp = exports.getPersonPysicalSiteClaims = exports.getJwtTokenSN = exports.getFavOptios = exports.findByUserApps = exports.findByUserAppAndFunctions = void 0;
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _apolloClient = _interopRequireDefault(require("cornerstone_ui_core/lib/apolloClient"));
var _createWorkflowAppolloClient = _interopRequireDefault(require("../../utils/createWorkflowAppolloClient"));
var _constants = require("../../constants");
var _externalSupplierNetClient = _interopRequireDefault(require("../../externalSupplierNetClient"));
var _utils = require("cornerstone_ui_core/lib/utils");
var _lodash = require("lodash");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
const GRAPHQL_RDS_GATEWAY_BASE_URL = process.env.NODE_ENV === "production" ? "/gateway_rds" + _constants.servicegraphql : _constants.servicebasepath + "/gateway_rds" + _constants.servicegraphql;
const gatewayclientRDS = (0, _createWorkflowAppolloClient.default)(GRAPHQL_RDS_GATEWAY_BASE_URL, {
  appName: "RDS"
});
const GRAPHQL_SCS_GATEWAY_BASE_URL = process.env.NODE_ENV === "production" ? "/gateway_scs" + _constants.servicegraphql : _constants.servicebasepath + "/gateway_scs" + _constants.servicegraphql;
const gatewayclientSCS = (0, _createWorkflowAppolloClient.default)(GRAPHQL_SCS_GATEWAY_BASE_URL, {
  appName: "SCS"
});
// export const performEsignAuth = input => {
//   return client
//     .query({
//       query: gql`
//         query($input: EsignAuthorisation) {
//           performEsignAuth(input: $input)
//         }
//       `,
//       variables: {
//         input
//       }
//     })
//     .then(({ data, errors }) => {
//       if (!errors) {
//         return data;
//       }
//     })
//     .catch(errorHandler);
// };
const performEsignAuth = input => {
  return _apolloClient.default.query({
    query: (0, _graphqlTag.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        query ($input: EsignAuthorisation) {\n          performEsignAuth(input: $input)\n        }\n      "]))),
    variables: {
      input
    }
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref => {
    let {
      data,
      errors
    } = _ref;
    if (!errors) {
      return data;
    }
  }).catch(_utils.errorHandler);
};
exports.performEsignAuth = performEsignAuth;
const findByUserApps = userId => {
  return _apolloClient.default.query({
    query: (0, _graphqlTag.default)("\n        {\n          findByUserApps(userId: \"".concat(userId, "\") {\n            userId\n            appNames\n            isDataDogEnabled\n            applicationId\n            clientToken\n            brands\n            roles {\n              appName\n              appRoles\n              appFns\n              jwtToken\n             jwtCacheKey\n            }\n          }\n        }\n    ")),
    fetchPolicy: "network-only"
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref2 => {
    let {
      data
    } = _ref2;
    return data.findByUserApps;
  }).catch(_utils.errorHandler);
};
exports.findByUserApps = findByUserApps;
const findByUserAppAndFunctions = _ref3 => {
  let {
    appName = "",
    userId
  } = _ref3;
  return _apolloClient.default.query({
    query: (0, _graphqlTag.default)("\n      {\n        brands: findByUserApps(userId: \"".concat(userId, "\") {\n          brands\n        }\n        userAppFunctions : findByUserAppAndFunctions(appName: \"").concat(appName, "\", userId :\"").concat(userId, "\"){\n          userId\n          jwtToken\n          appName\n          appRoles\n          appFns\n          rdsPerId\n          userNumber\n          cc{\n            v\n            k\n          }\n        }\n        userinfo : getUser(userId: \"").concat(userId, "\") {\n          userId\n          firstName\n          lastName\n          Dept\n\t\t      emailId\n        }\n        profileImage : getProfileImage(userId: \"").concat(userId, "\") {\n          userId\n          firstName\n          lastName\n          profileImage\n        }\n      }\n    ")),
    fetchPolicy: "network-only"
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref4 => {
    let {
      data
    } = _ref4;
    return data;
  }).then(_ref5 => {
    let {
      brands,
      userinfo,
      userAppFunctions,
      profileImage
    } = _ref5;
    let userInfoTemp = [];
    if (userinfo && userinfo.length > 0) userInfoTemp = {
      ...userinfo[0],
      email: userinfo[0].emailId,
      name: "".concat(userinfo[0].firstName, " ").concat(userinfo[0].lastName),
      department: userinfo[0]
    };
    let newUserAppFunctions = {
      ...userAppFunctions
    };
    let personId = userAppFunctions.rdsPerId;
    newUserAppFunctions.personId = personId;
    return {
      brands,
      userinfo: userInfoTemp,
      userAppFunctions: newUserAppFunctions,
      profileImage
    };
  }).catch(_utils.errorHandler);
};
exports.findByUserAppAndFunctions = findByUserAppAndFunctions;
const isActionTrackingToBeAcknowledged = input => {
  return gatewayclientRDS.query({
    query: (0, _graphqlTag.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        query getAllActionTrackingMyselfPaged(\n          $input: ActionTrackingPagedRequestVO\n        ) {\n          getAllActionTrackingMyselfPaged(input: $input) {\n            pageCount\n          }\n        }\n      "]))),
    variables: {
      input: input,
      shouldSuppressTimeoutError: true,
      isToDo: true
    }
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref6 => {
    let {
      data
    } = _ref6;
    return data.getAllActionTrackingMyselfPaged;
  }).catch(_utils.errorHandler);
};
exports.isActionTrackingToBeAcknowledged = isActionTrackingToBeAcknowledged;
const getJwtTokenSN = (userId, appName) => {
  return _externalSupplierNetClient.default.query({
    query: (0, _graphqlTag.default)("\n    {\n      getJWTTokenSNWithoutCong(userId: \"".concat(userId, "\", appName: \"").concat(appName, "\") {\n        jwtToken\n        jwtCacheKey\n      }\n    }\n")),
    fetchPolicy: "network-only"
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref7 => {
    let {
      data
    } = _ref7;
    return data.getJWTTokenSNWithoutCong;
  }).catch(_utils.errorHandler);
};
exports.getJwtTokenSN = getJwtTokenSN;
const getUserSessionService = cacheKey => {
  return _externalSupplierNetClient.default.query({
    query: (0, _graphqlTag.default)("\n    {\n      getUserSession(identifierKey: \"".concat(cacheKey, "\") {\n        userId\n        cacheKey\n        jwtToken\n      }\n    }\n")),
    fetchPolicy: "network-only"
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref8 => {
    let {
      data
    } = _ref8;
    return data.getUserSession;
  }).catch(_utils.errorHandler);
};
exports.getUserSessionService = getUserSessionService;
const getPersonasForUserApp = (userId, appName) => {
  return _apolloClient.default.query({
    query: (0, _graphqlTag.default)("\n     {\n      getPersonasForUserApp(userId: \"".concat(userId, "\", appName: \"").concat(appName, "\") {\n        personaName\n        personaDesc\n      }\n    }\n  ")),
    fetchPolicy: "network-only"
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref9 => {
    let {
      data
    } = _ref9;
    return data.getPersonasForUserApp;
  }).catch(_utils.errorHandler);
};
exports.getPersonasForUserApp = getPersonasForUserApp;
const getPersonPysicalSiteClaims = () => {
  return gatewayclientRDS.query({
    query: (0, _graphqlTag.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        {\n          physicalSiteClaims: getPersonPysicalSiteClaims {\n            userNumId\n            perId\n            phsId\n            prlId\n            active\n            primary\n            userId\n            location\n            siteDescription\n            siteAddress\n          }\n        }\n      "]))),
    fetchPolicy: "no-cache"
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref10 => {
    let {
      data,
      errors
    } = _ref10;
    if (!errors) {
      data.physicalSiteClaims = data.physicalSiteClaims && data.physicalSiteClaims.length > 0 && data.physicalSiteClaims.sort(function (a, b) {
        return a.primary - b.primary;
      });
      return data;
    } else return errors;
  }).catch(_utils.errorHandler);
};
exports.getPersonPysicalSiteClaims = getPersonPysicalSiteClaims;
const selectingPersonDetail = _ref11 => {
  let {
    userNumId,
    primary
  } = _ref11;
  return gatewayclientRDS.mutate({
    mutation: (0, _graphqlTag.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      mutation{\n        locationDetail: selectingPersonDetail(userNumId:", ", primary:", "){\n          statusMessage\n          id\n          statusCode\n        }}\n      "])), userNumId, primary)
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref12 => {
    let {
      data
    } = _ref12;
    return data;
  }).catch(_utils.errorHandler);
};
exports.selectingPersonDetail = selectingPersonDetail;
const getShortcutNavigationOptions = () => {
  return gatewayclientRDS.query({
    query: (0, _graphqlTag.default)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        {\n          menusFromDB: getShortcutNavigationOptions {\n            option\n            categoryVOList {\n              menuCategory\n              functionKey\n              pathUrl\n              subCategoryVOList {\n                subCategory\n                functionKey\n                pathUrl\n              }\n            }\n          }\n        }\n      "]))),
    fetchPolicy: "network-only"
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref13 => {
    let {
      data,
      errors
    } = _ref13;
    return data;
  }).catch(_utils.errorHandler);
};
exports.getShortcutNavigationOptions = getShortcutNavigationOptions;
const getFavOptios = pageKey => {
  return gatewayclientRDS.query({
    query: (0, _graphqlTag.default)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        {\n          favOptions: getFavOptios (pageKey:\"", "\") {\n            menuOption\n            menuCategory\n            subCategory\n            functionKey\n            catOrder\n          }\n        }\n      "])), pageKey),
    fetchPolicy: "network-only"
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref14 => {
    let {
      data,
      errors
    } = _ref14;
    return data;
  }).catch(_utils.errorHandler);
};
exports.getFavOptios = getFavOptios;
const saveFavOptions = input => {
  return gatewayclientRDS.mutate({
    mutation: (0, _graphqlTag.default)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        mutation ($input: FavOptionsVO) {\n          saveFavOptions(input: $input) {\n            id\n            statusMessage\n            statusCode\n          }\n        }\n      "]))),
    variables: {
      input
    }
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref15 => {
    let {
      data
    } = _ref15;
    return data;
  }).catch(_utils.errorHandler);
};
exports.saveFavOptions = saveFavOptions;